declare namespace $ {

	type $mol_paragraph__title_shm_hitalama_opencode_tool_card_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_opencode_tool_card_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['status_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_copy__title_shm_hitalama_opencode_tool_card_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_shm_hitalama_opencode_tool_card_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['copy_text'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_view__sub_shm_hitalama_opencode_tool_card_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_opencode_tool_card_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['input'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_opencode_tool_card_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['options'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_opencode_tool_card_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['content'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_opencode_tool_card_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_tool_card['error'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	export class $shm_hitalama_opencode_tool_card extends $mol_view {
		status( ): string
		title( ): string
		Title( ): $mol_paragraph
		status_title( ): string
		Status( ): $mol_paragraph
		copy_text( ): string
		Copy( ): $mol_button_copy
		Head( ): $mol_view
		input( ): string
		Input( ): $shm_hitalama_text
		options( ): readonly(any)[]
		Options( ): $mol_view
		content( ): string
		Content( ): $shm_hitalama_text
		error( ): string
		Error( ): $shm_hitalama_text
		rows( ): readonly(any)[]
		name( ): string
		attr( ): ({ 
			'status': ReturnType< $shm_hitalama_opencode_tool_card['status'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): ReturnType< $shm_hitalama_opencode_tool_card['rows'] >
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map